











































































import Vue from "vue";
import { mapGetters } from "vuex";

import { GetNotificationSubscriptionCommand } from "@/model/communication/notification/GetNotificationSubscriptionCommand";
import { SetNotificationSubscriptionCommand } from "@/model/communication/notification/SetNotificationSubscriptionCommand";

import { NotificationTopicEnum, topicNeedInstallations, topicToType, topicToPrivilege } from "@/model/data/notifications/NotificationTopicEnum";
import { NotificationSubscriptionClientData } from "@/model/data/notifications/NotificationSubscriptionClientData";
import { NotificationChannelEnum } from "@/model/data/notifications/NotificationChannelEnum";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

import DeviceTree from "@/components/DeviceTree/index.vue";
import { SetNotificationSubscriptionReqData } from "@/model/communication/notification/SetNotificationSubscriptionReqData";

export default Vue.extend({
    components: { DeviceTree },
    data() {
        return {
            installationDialogs: {},
            loading: false,
            deviceTreeloading: false,
            subscriptions: [],
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),
        subscriptionsTypes() {
            let subscriptionsTypes = [];
            for (let topicId in NotificationTopicEnum) {
                if (
                    !isNaN(Number(topicId)) &&
                    !subscriptionsTypes.includes(this.topicToType(Number(topicId) as NotificationTopicEnum)) &&
                    this.authUserHasPrivilege(this.topicToPrivilege(Number(topicId) as NotificationTopicEnum))
                ) {
                    subscriptionsTypes.push(this.topicToType(Number(topicId) as NotificationTopicEnum));
                }
            }
            return subscriptionsTypes;
        },
    },
    methods: {
        topicNeedInstallations,
        topicToType,
        topicToPrivilege,
        async getNotificationSubscription() {
            this.loading = true;
            let res = await new GetNotificationSubscriptionCommand().execute();
            // = res.subscriptions;
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.subscriptions.length = 0;

                for (let topicId in NotificationTopicEnum) {
                    if (!isNaN(Number(topicId))) {
                        let existingSub = res.subscriptions.find((c) => c.topic == Number(topicId));

                        if (existingSub) {
                            this.subscriptions.push(existingSub);
                        } else {
                            let defaultSub = new NotificationSubscriptionClientData();
                            defaultSub.topic = Number(topicId);
                            defaultSub.installationNames = [];
                            defaultSub.active = false;
                            defaultSub.channel = NotificationChannelEnum.Mail;
                            this.subscriptions.push(defaultSub);
                        }
                    }
                }
            }

            this.loading = false;
        },
        async save() {
            this.loading = true;

            let reqData = new SetNotificationSubscriptionReqData(this.subscriptions);
            await new SetNotificationSubscriptionCommand(reqData).execute();

            this.loading = false;
            this.getNotificationSubscription();
        },
        async fetchAllDeviceTree() {
            this.deviceTreeloading = true;
            this.deviceTreeloading = false;
        },
        getSubscriptionsOfType(type: string) {
            return this.subscriptions.filter((s) => this.topicToType(s.topic) == type && this.authUserHasPrivilege(this.topicToPrivilege(s.topic)));
        },
    },
    created() {
        this.fetchAllDeviceTree();
        this.getNotificationSubscription();
    },
});
